var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"noticia"},[_c('v-container',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"md9":"","xs12":""}},[_c('Noticia')],1),_c('v-flex',{attrs:{"md3":"","xs12":""}},[_c('Servicios')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }